import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=6cbff2d8"
import script from "./PaymentSettings.vue?vue&type=script&lang=ts"
export * from "./PaymentSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cbff2d8')) {
      api.createRecord('6cbff2d8', component.options)
    } else {
      api.reload('6cbff2d8', component.options)
    }
    module.hot.accept("./PaymentSettings.vue?vue&type=template&id=6cbff2d8", function () {
      api.rerender('6cbff2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/PaymentSettings.vue"
export default component.exports